
import components from '../../components';
import { EntryPoint } from '../EntryPoint';

import * as embeddedSearch from '../../components/EmbeddedSearch/EmbeddedSearch';

export class CoreEntryPoint extends EntryPoint {

  initialize() {
    components.register(embeddedSearch.create, { ajaxable: false });
  }

}






// WEBPACK FOOTER //
// ./uikit/entryPoints/Core/CoreEntryPoint.js